import React, { memo } from 'react';

const BigOther = memo(({ size = 56 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3693 4.66666H14.816C19.6227 4.66666 23.5194 8.56528 23.5194 13.3744V21.1949C23.5194 22.4789 22.4694 23.5294 21.186 23.5294H13.3693C8.56268 23.5294 4.66602 19.6308 4.66602 14.8217V13.3744C4.66602 8.56528 8.56268 4.66666 13.3693 4.66666Z"
        stroke="#1A9EB3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M13.3693 32.4706H21.186C22.4694 32.4706 23.5194 33.5212 23.5194 34.8051V42.6257C23.5194 47.4348 19.6227 51.3334 14.816 51.3334H13.3693C8.56268 51.3334 4.66602 47.4348 4.66602 42.6257V41.1783C4.66602 36.3693 8.56268 32.4706 13.3693 32.4706Z"
        stroke="#1A9EB3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M41.1818 4.66666H42.6285C47.4352 4.66666 51.3318 8.56528 51.3318 13.3744V14.8217C51.3318 19.6308 47.4352 23.5294 42.6285 23.5294H34.8118C33.5285 23.5294 32.4785 22.4789 32.4785 21.1949V13.3744C32.4785 8.56528 36.3752 4.66666 41.1818 4.66666Z"
        stroke="#1A9EB3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M34.7904 32.4706H42.607C47.4137 32.4706 51.3104 36.3693 51.3104 41.1783V42.6257C51.3104 47.4348 47.4137 51.3334 42.607 51.3334H41.1604C36.3537 51.3334 32.457 47.4348 32.457 42.6257V34.8051C32.457 33.5212 33.507 32.4706 34.7904 32.4706Z"
        stroke="#1A9EB3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
});

export default BigOther;
